// extracted by css-extract-rspack-plugin
export default {"mainCopyBody":"_a784613f","button":"_effa11f7","linkWrapper":"_c634e172","label":"_5dba8187"};